module.exports = "/images/general-policy.svg?9642e6a39679dbabfb2eea70b61185f5";